jQuery(document).ready(function()
{
   jQuery('.faqtoggle').on('change',function(){
       var selectedValue = jQuery('option:selected',this).val();
       if(selectedValue)
       {
         var countcc = jQuery('.ap-contentcollapsible').length; 
         jQuery('.ap-contentcollapsible').hide();
         var counterCheck = 1;
         jQuery('.ap-contentcollapsible').each(function()
           {
              if(counterCheck == selectedValue)
              {
                jQuery(this).show('slow'); 
              }
              counterCheck++;
           });
       }
       else
       {
         jQuery('.ap-contentcollapsible').show('slow'); ;
       }
   });

  jQuery(".mobile-nav__link").on("click",function(){
    jQuery(this).closest(".mobile-nav__item").find(".mobile-nav__link_btn").prop("aria-expanded", true);
  });
  if (jQuery(window).width() <= 999) {
    jQuery(".navbar-search.desktop-show").remove(); 
  }
});